import { AtlSelectOption } from '../forms/select';

export interface AtlExpandingSearchProps {
   listClassName?: string;
   displayResults?: boolean;
   variant?: ExpandingSearchIconVariant;
   options?: Array<AtlSelectOption> | undefined;
}

export enum ExpandingSearchIconVariant {
   Default = 'Default',
   Nav = 'Nav',
   Cta = 'Cta',
   Secondary = 'Secondary',
   Destructive = 'Destructive',
   Light = 'Light',
}
